<script setup lang="ts">
const { closeChallenge } = useLayoutStore();
const { isModalChallengeOpen } = storeToRefs(useLayoutStore());

function closeChallengeModal() {
  closeChallenge();
}

function onClickButtonReloadPage() {
  window.location.reload();
}

onBeforeMount(() => {
  window.closeChallengeModal = closeChallengeModal;
});
</script>

<template>
  <ClientOnly>
    <Teleport to="body">
      <div
        v-if="isModalChallengeOpen"
        :class="$style.challenge"
      >
        <iframe
          frameborder="0"
          scrolling="no"
          src="/api/challenge"
          title="Challenge Iframe"
        ></iframe>
        <div :class="$style.actionBottomBar">
          <span :class="$style.text">
            {{ $t('auth.sign_up.challenge_message') }}
          </span>

          <div :class="$style.buttons">
            <button
              :class="$style.white"
              @click="onClickButtonReloadPage()"
            >
              {{ $t('auth.sign_up.reload') }}
            </button>
            <button
              :class="$style.red"
              @click="closeChallengeModal()"
            >
              {{ $t('general.close') }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </ClientOnly>
</template>

<style module lang="scss">
.challenge {
  @apply w-full h-full fixed top-0 left-0 bg-bg-primary/90 z-[999999] flex flex-col;

  iframe {
    @apply w-full h-full border-0 bg-white relative z-10;
  }

  .actionBottomBar {
    @apply bg-bg-primary p-2.5 border-t border-t-texts/10 border-solid flex items-center justify-center text-2xs md:text-xs font-bold flex-col xs:flex-row gap-1 xs:gap-4;

    .text {
      @apply text-texts/80;
    }

    .buttons {
      @apply flex gap-2;

      button {
        @apply text-2xs font-semibold px-2 py-0.5 rounded-full;

        &.white {
          @apply bg-white text-black;
        }

        &.red {
          @apply bg-error text-white;
        }
      }
    }
  }
}
</style>
